export default __webpack_public_path__ + "static/media/logo-lado.030c62a2.svg";